import { MERCHANTID_MARKET_NAME_MAPPING } from 'helpers/MarketplaceUtils';

// TODO Overriding Catalog for vrsnl product until we don't override the useContext itself
export const cloudCatalogUsingMerchantId = merchantId => {
  if (MERCHANTID_MARKET_NAME_MAPPING[merchantId] === 'versional') {
    return vrsnlCatalog;
  }
};

const vrsnlCatalog = {
  'url': 'https://api.cloudcatalog.vrsnl.com',
  'siteId': 20,
  'subsiteId': 56
};

export default cloudCatalogUsingMerchantId;
